import React from 'react';
import { WbEventHandlerMixins } from '../../../utils/common';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import CKEDITOR from '@workboard/ckeditor5-build-wobo'
import KRService from '../../../okr/services/kr.service';
import EmojiContainer from '../../emojis/emojis';

export default class KrCommentEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editVal: this.props.metricDataComment,
            ck_editor: null
        };
        this.addEmoticonToEditor = this.addEmoticonToEditor.bind(this);
        this.focusElement = this.focusElement.bind(this);
        this.mentionCustomization = this.mentionCustomization.bind(this);
        this.services = new KRService();
    }

    componentDidMount() {
        this.focusElement();
    }

    focusElement() {
        const mdId = this.props.metricDataId;
        let ele = document.querySelector(`#update-kr-comment-view-${mdId}`);
        if (ele) {
            WbEventHandlerMixins.descAutoHeight(ele, 11);
        }
    }

    setEditor = (editor) => {
        this.setState({
            ck_editor: editor
        });
    }

    addEmoticonToEditor(mdId, src) {
        const imgDiv = `<img class="smiley-editor-emoticon" src="${src}" />`;
        const updEditVal = $(`.updateKRCommentEditor[data-md-id="${mdId}"]`).html() + imgDiv;
        this.setState({
            editVal: updEditVal,
        });
        this.focusElement();
    }

    mentionCustomization(editor) {
        // The upcast converter will convert <a class="mention" href="" data-user-id="">
        // elements to the model 'mention' attribute.
        editor.conversion.for('upcast').elementToAttribute({
            view: {
                name: 'a',
                key: 'data-mention',
                classes: 'mention',
                attributes: {
                    'data-user-id': true,
                    "href": true
                }
            },
            model: {
                key: 'mention',
                value: viewItem => {
                    // The mention feature expects that the mention attribute value
                    // in the model is a plain object with a set of additional attributes.
                    // In order to create a proper object, use the toMentionAttribute helper method:
                    const mentionAttribute = editor.plugins.get('Mention').toMentionAttribute(viewItem, {
                        // Add any other properties that you need.
                        userId: viewItem.getAttribute('data-user-id'),
                        link: viewItem.getAttribute('href'),
                    });

                    return mentionAttribute;
                }
            },
            converterPriority: 'high'
        });

        // Downcast the model 'mention' text attribute to a view <a> element.
        editor.conversion.for('downcast').attributeToElement({
            model: 'mention',
            view: (modelAttributeValue, { writer }) => {
                // Do not convert empty attributes (lack of value means no mention).
                if (!modelAttributeValue) {
                    return;
                }
                const className = modelAttributeValue.link.indexOf("workstreams") === -1 ? "selectedUser mention" : "selectedTeam mention";
                return writer.createAttributeElement('a', {
                    class: className,
                    'data-mention': modelAttributeValue.id,
                    'data-user-id': modelAttributeValue.userId,
                    'href': modelAttributeValue.link
                }, {
                    // Make mention attribute to be wrapped by other attribute elements.
                    priority: 20,
                    // Prevent merging mentions together.
                    id: modelAttributeValue.uid
                });
            },
            converterPriority: 'high'
        });
    }

    getFeedItems = async (queryText) => {
        return await this.services.getUserAndTeamData({ 'term': queryText, 'viaAI': true, 'excludeAIAgents': true, 'includeOwnAgents': true }).then((response) => {
            response.data.map((items) => {
                items["id"] = `@${items["label"]}`;
                items["userId"] = items["value"];
                items["link"] = wbConfig.baseDomainUrl + '/memberProfile/index?id=' + items['value'];
                if (items.isTeamSearch) {
                    items["link"] = wbConfig.baseDomainUrl + '/activity/workstreams?teamId=' + items['value'] + '&teamView&selectedTab=showTeam';
                }
            });
            return response.data;
        }).catch((err) => {
            console.log('err', err);
        });
    }

    customItemRenderer = (item) => {
        const itemElement = document.createElement('li');
        itemElement.classList.add('mention-suggestions-li');

        if (!item.isTeamSearch) {
            itemElement.innerHTML = '<span class="pR5"><img class="fitProfileImage roundFramePhoto goalMentionsImg" src="' + item.picSrc + '" /><span style="padding-left: 5px;">' + item.label + '</span>';
        } else {
            itemElement.innerHTML = '<span class="pR5"><img class="fitProfileImage roundFramePhoto goalMentionsImg" src="../images/icons/menu/topnavigation/teams_new.png" /><span style="padding-left: 5px;">' + item.label + '</span>';
        }

        return itemElement;
    }

    render() {
        const mId = this.props.metricId;
        const mdId = this.props.metricDataId;
        const placeHolder = this.props.placeholder ? this.props.placeholder : "Add a narrative";
        const { ck_editor } = this.state;
        return (
            <div className="updateKRNarrateWrapper">
                <div className="updateKRCommentEditorDiv">
                    <input type="hidden" id={`updateKRCommentEditor_${mdId}`} value={this.state.editVal} name={`metric[${mId}][${mdId}][cmt]`} />
                    <input type="hidden" id={`updateKRCommentEditorUser_${mdId}`} value="" name={`metric[${mId}][${mdId}][mentionUserId]`} />
                    <input type="hidden" id={`updateKRCommentEditorTeam_${mdId}`} value="" name={`metric[${mId}][${mdId}][mentionTeamId]`} />
                    <CKEditor
                        editor={CKEDITOR.BalloonEditor}
                        id={`update-kr-comment-view-${mdId}`}
                        data={this.state.editVal}
                        config={{
                            licenseKey: window.ckeditorLicenseKey,
                            placeholder: placeHolder,
                            toolbar: {
                                items: ['bold', 'italic', 'link', 'undo', 'numberedList', 'bulletedList', 'strikethrough', 'underline', 'horizontalLine']
                            },
                            plugins: [...CKEDITOR.BalloonEditor.builtinPlugins, this.mentionCustomization],
                            mention: {
                                feeds: [
                                    {
                                        marker: '@',
                                        feed: this.getFeedItems,
                                        itemRenderer: this.customItemRenderer
                                    }
                                ]
                            }
                        }}
                        onChange={(e, editor) => {
                            const data = editor.getData();
                            $(`#updateKRCommentEditor_${mdId}`).val(data);
                            const mentionsTeam = $(data).find('.selectedTeam');
                            const mentionsUser = $(data).find('.selectedUser');
                            if (mentionsTeam) {
                                const teamids = [];
                                $(mentionsTeam).each((index, mention) => {
                                    var id = $(mention).attr('data-user-id');
                                    if (teamids.indexOf(id) === -1) {
                                        teamids.push(id);
                                    }
                                });
                                const totalteamId = teamids.join(',')
                                $(`#updateKRCommentEditorTeam_${mdId}`).val(totalteamId);
                            }
                            if (mentionsUser) {
                                const userids = [];
                                $(mentionsUser).each((index, mention) => {
                                    var id = $(mention).attr('data-user-id');
                                    if (userids.indexOf(id) === -1) {
                                        userids.push(id);
                                    }
                                });
                                const totalUserId = userids.join(',')
                                $(`#updateKRCommentEditorUser_${mdId}`).val(totalUserId);
                            }
                        }}
                        onReady={editor => {
                            this.setEditor(editor);
                        }}
                    />
                </div>
            </div>
        );
    }
}
